export default __webpack_public_path__ + "coinholio.singlepage.01.9cee1fe39659e5dc6c794962d407e651.webm";